import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatImageName, formatPrice, handleError } from "../../utils/functions";
import axiosInstance from "../../config/axios.config";
import { useSelector } from "react-redux";
import useCurrency from "../../hooks/useCurrency";
import { useTranslation } from "react-i18next";
const ProductCard = ({ item, className = "col-lg-4 col-sm-4 col-6", removeFunction }) => {
  const [currency] = useCurrency();
  const { user } = useSelector((state) => state.auth);
  const [wishlist, setWishlist] = useState(item?.wishlist?.includes(user?._id) || false);
  const { t } = useTranslation();
  const handleWishlist = async (id) => {
    try {
      await axiosInstance.post("/wishlist", { productId: id });
      setWishlist((prev) => !prev);
      removeFunction?.(id);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className={className}>
      <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
        {user && (
          <button onClick={() => handleWishlist(item.slug)} className="wishlistButtonC rounded-56 d-flex">
            <i className={`${wishlist ? "ph-fill text-danger" : "ph"} ph-heart`}></i>
          </button>
        )}
        <Link to={`/products/${item.slug}`} className="product-card__thumb flex-center">
          <img src={formatImageName(item?.card) || "/assets/images/grey.png"} alt={t("productImage")} />
        </Link>
        <div className="product-card__content w-100 p-sm-2">
          <h6 className="title text-lg fw-semibold mt-12 mb-8">
            <Link to={`/products/${item.slug}`} className="link text-line-2">
              {item?.name?.length > 35 ? `${item?.name?.slice(0, 35)}...` : item?.name}
            </Link>
          </h6>
          <div className="flex-align gap-4">
            <span className="text-main-600 text-md d-flex">
              <i className="ph-fill ph-storefront" />
            </span>
            <span className="text-gray-500 text-xs">
              {t("by")} {item?.shopId?.shopName}
            </span>
          </div>
          <div className="product-card__content ">
            <div className="product-card__price mb-8">
              <span className="text-heading text-md fw-semibold">{formatPrice(item?.price, currency)}</span>
            </div>
            <div className="d-md-block d-none">
              <div className="flex-align  productRating gap-6">
                <span className="text-md fw-bold text-gray-600">{item?.rating}</span>
                <span className="text-15 fw-bold text-warning-600 d-flex">
                  <i className="ph-fill ph-star" />
                </span>
                <span className="text-md fw-bold text-gray-600">
                  ({item.ratingCount || 0} {t("reviews")})
                </span>
              </div>
            </div>
            <Link
              to={`/products/${item.slug}`}
              className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill gap-8 mt-12 w-100 justify-content-center"
            >
              {t("addToCart")} <i className="ph ph-shopping-cart" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
